<template>
  <div ref="fieldInfo" class="f-field-info">
    <div class="f-field-info-container">
      <XIcon class="close" @click="close"/>

      <p><strong>ID: </strong>{{ field.id }}</p>
      <p><strong>{{ column.name }}: </strong>{{ field.value }}</p>
      <p v-if="publicTable">
        <strong>URL: </strong>
        <a :href="fieldUrl" target="_blank">{{ fieldUrl }}</a>
      </p>

    </div>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons'

const clickOutside = (element, callback) => {
  document.addEventListener('click', event => {
    const isClickInside = element.contains(event.target)
    if (!isClickInside) callback()
  })
}

const domain = {
  production: 'https://custom-table.platform.brobot.com.br',
  staging: 'https://custom-table.platform-staging.brobot.com.br',
}[process.env.VUE_APP_ENV] || 'http://localhost:3001'

export default {
  components: { XIcon },
  computed: {
    fieldUrl() {
      return `${domain}/v1/public_tables/${this.table.uuid}/fields/${this.field.id}`
    },
    publicTable() {
      return this.table.public
    },
  },
  data: () =>({
    load: false
  }),
  methods: {
    close() {
      this.$emit('closed')
    },
  },
  mounted() {
    setTimeout(() => {
      clickOutside(this.$refs.fieldInfo, () => this.close())
    }, 1)
  },
  name: 'FieldInfo',
  props: {
    column: {
      required: true,
      type: Object
    },
    field: {
      required: true,
      type: Object
    },
    table: {
      require: true,
      type: Object
    }
  }
}
</script>

<style scoped>
.f-field-info {
  position: absolute;
  background-color: white;
  white-space: nowrap;
  top: 0;
  right: 0;
  padding: 8px 16px;
  z-index: 2;
  border-radius: 4px;
  box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.2);
  overflow: auto;
}

.f-field-info-container {
  position: relative;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
</style>